import { Typography } from '@mui/material';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import { TwContainer } from '../../typings/tw.types';

interface RoundInfoProps extends TwContainer {
  style?: CSSProperties;
}

const RoundInfo = ({ children, containerClasses, style }: RoundInfoProps) => {
  return (
    <div 
      className={classNames('bg-light-blue rounded-full text-center px-8 py-3 w-max uppercase', containerClasses)}
      style={style}
    >
      <Typography variant="body2" style={{ fontFamily: 'var(--fontPrimary)', color: style?.color || 'inherit' }}>
        {children}
      </Typography>
    </div>
  );
};

export default RoundInfo;
